// Badge + background-color options for Create Club, mirroring the design
// prototype (Caissa Clubs.dc.html: badgeList() + BG palette).
import type { PieceKey } from "./clubPieces";

// 12 curated badges. `piece` selects the crest figure (chess piece or emblem)
// rendered by <ClubBadge/>; `id` is the value persisted as the club's badge_id.
export const BADGES: { id: string; name: string; piece: PieceKey }[] = [
  { id: "pawn", name: "Pawn", piece: "pawn" },
  { id: "knight", name: "Knight", piece: "knight" },
  { id: "bishop", name: "Bishop", piece: "bishop" },
  { id: "rook", name: "Rook", piece: "rook" },
  { id: "queen", name: "Queen", piece: "queen" },
  { id: "king", name: "King", piece: "king" },
  { id: "crown", name: "Crown", piece: "crown" },
  { id: "star", name: "Star", piece: "star" },
  { id: "trophy", name: "Trophy", piece: "trophy" },
  { id: "shield", name: "Shield", piece: "shield" },
  { id: "flame", name: "Flame", piece: "flame" },
  { id: "sword", name: "Swords", piece: "sword" },
];

// 5 preset background colors (design's top5), each a base + darker ring used to
// build the swatch's radial gradient. A 6th "custom" swatch is a color picker.
export const BADGE_BG_COLORS: { value: string; ring: string; name: string }[] = [
  { value: "#3DAB9E", ring: "#2C7F76", name: "Aqua" },
  { value: "#E17846", ring: "#B25F14", name: "Orange" },
  { value: "#67B3E1", ring: "#3E88BB", name: "Blue" },
  { value: "#937ADB", ring: "#6B54B0", name: "Purple" },
  { value: "#D1AB41", ring: "#A9861F", name: "Gold" },
];

export const DEFAULT_BADGE_ID = BADGES[0].id;
export const DEFAULT_BADGE_BG = BADGE_BG_COLORS[0].value;

// Piece figure color per selected White/Black toggle (design pieceEl()).
export const PIECE_WHITE = "#F5EFE0";
export const PIECE_BLACK = "#2C2523";

// Darken a hex by pct (0..1) — mirrors the prototype's shadeHex(), used to
// derive a ring for custom-picked colors.
export function shadeHex(hex: string, pct: number): string {
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const n = parseInt(h, 16);
  let r = (n >> 16) & 255;
  let g = (n >> 8) & 255;
  let b = n & 255;
  r = Math.round(r * (1 - pct));
  g = Math.round(g * (1 - pct));
  b = Math.round(b * (1 - pct));
  return "#" + [r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("");
}
